import { Input } from '@new-components/elements';
import { useFormContext } from '@hooks/react-hook-form';

import ApplicationCard from '../../../../../application-card';
import SectionTitle from '../../../../../section-title';
import { CloseFamilyProps } from './types';

const CloseFamily = (props: CloseFamilyProps) => {
  const { readonly } = props;
  const {
    fieldsRef,
    formState: { isSubmitting, isSubmitSuccessful },
    trigger,
  } = useFormContext();
  return (
    <ApplicationCard>
      <SectionTitle title='Informasi Keluarga Dekat' />
      <Input
        ref={(e) => (fieldsRef.current['closeKinName'] = e)}
        disabled={readonly || (isSubmitting && !isSubmitSuccessful)}
        name='closeKinName'
        label='Nama Keluarga Dekat'
        placeholder='nama keluarga dekat'
      />
      <Input
        ref={(e) => (fieldsRef.current['closeKinMobilePhone'] = e)}
        disabled={readonly || (isSubmitting && !isSubmitSuccessful)}
        type='tel'
        name='closeKinMobilePhone'
        label='Nomor HP Keluarga Dekat'
        onKeyUp={() => trigger('closeKinMobilePhone')}
        placeholder='08xxxxxxxxxx'
      />
    </ApplicationCard>
  );
};

export default CloseFamily;
